import { matchPath } from 'react-router-dom';

export const ROUTE_PATHS = {
  home: '/',
  login: '/login',
  register: '/register',
  forgotPassword: '/forgot-password',
  info: '/info',
  waitingForHr: '/waiting-for-hr',
  platformAccessRevoked: '/platform-access-revoked',
  openCall: '/events/opencall/:eventId',
  editEvent: '/events/:eventId',
  resetPassword: '/reset-password/:token',
  confirmEmailChange: '/confirm-email-change/:token',
  verifyEmail: '/verify-email/:token',
};

/** Public routes (non-PrivateRoute) used by App.js and auth redirect logic */
export const PUBLIC_ROUTES = [
  { path: ROUTE_PATHS.home, exact: true },
  { path: ROUTE_PATHS.login, exact: true },
  { path: ROUTE_PATHS.register, exact: true },
  { path: ROUTE_PATHS.forgotPassword, exact: true },
  { path: ROUTE_PATHS.info, exact: true },
  { path: ROUTE_PATHS.waitingForHr, exact: true },
  { path: ROUTE_PATHS.platformAccessRevoked, exact: true },
  { path: ROUTE_PATHS.openCall, exact: true },
  { path: ROUTE_PATHS.editEvent, exact: true },
  { path: ROUTE_PATHS.resetPassword, exact: true },
  { path: ROUTE_PATHS.confirmEmailChange, exact: true },
  { path: ROUTE_PATHS.verifyEmail, exact: true },
];

export const isPublicAuthRoute = (pathname = window.location.pathname) =>
  PUBLIC_ROUTES.some((route) => matchPath(pathname, route));
